<template>
            <v-card flat>
            <v-card-title>
              <span class="headline">Create Service Account</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="validUser" @submit.prevent>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.name" :rules="[rules.required]" label="Name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.login" label="Username" prepend-icon="fas fa-user" :rules="[rules.required, rules.duplicate, rules.formatLogin]" ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                  <v-text-field autocomplete="new-password" v-model="editedItem.password" :rules="[rules.required, rules.format]" prepend-icon="fas fa-lock" type="password" label="Password"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                  <v-text-field v-model="confirmPassword" :rules="[rules.required, rules.match]" type="password" label="Confirm Password"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" rounded  :disabled="!validUser" :loading="saving" @click.native="save">Save</v-btn>
            </v-card-actions>
          </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment-timezone'
export default {
    data(){
      return {
        saving: false,
        editedItem: {
          id: -1,
          name: 'Service Account',
          login: 'vyopta_svc@domain.com',
          password: '',
          roles: [
            {id: 1, code: 'admin'} //admin
          ],
          timeZone: moment.tz.guess()
        },
        editedId: -1,
        activeUserOriginalPassword: '',
        validPwd: false,
        validUser: false,
        confirmPassword: '',
        rules: {
          required: value => !!value || 'Required.',
          match: value => value === this.editedItem.password || 'Passwords do not match',
          duplicate: value => this.loginNameIsNotDuplicate(value) || 'Login is already in use',
          formatLogin: value => this.validateLoginFormat(value),
          format: value =>
            /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?=\S+$).{8,}$/.test(value)
            || 'Password must have at least 8 characters without space, and must contain upper-case, lower-case, numeric and special characters'
        }
      }
  },
  computed: {
      ...mapGetters('user', {
          allUsers: 'activeUsers',
          orgContext: 'getOrgContext',
          orgName: 'getOrgName',
          orgDomain: 'getOrgDomain',
          timeZone: 'getOrgTimezone',
          isSU: 'isSU',
      }),
  },
  created() {
    this.editedItem.name = 'Service Account - ' + this.orgName;
    this.editedItem.login = 'vyopta_svc@' + this.orgDomain;
    this.editedItem.timeZone = this.timeZone;
  },
  methods: {
    loginNameIsNotDuplicate(login) {
      return !_.find(this.allUsers, { login });
    },
    getTimezoneNames() {
      return moment.tz.names();
    },
    async save() {
      this.editedItem.email = this.editedItem.login;

      this.saving = true;
      const success = await this.$store.dispatch("user/addOrUpdateUser", this.editedItem);

      if (success) {
        await this.$store.dispatch('user/getAllUsers')
        this.saving = false
        this.$emit('success', this.editedItem.login)
      } else {
        this.saving = false
      }
    },
    validateLoginFormat(value) {
      let regexDomain = new RegExp('^((?!@).)*@' + this.orgDomain + '$','i')
      let regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!this.isSU) {
        return regexDomain.test(value) || 'Format should match ...@' + this.orgDomain
      }
      return regexEmail.test(value) || 'Must be a valid email'
    }
  }
}
</script>
